export { LoyaltyPointsHistoryHeader } from './LoyaltyPointsHistoryHeader';
